import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import './pagenation.scss';
import { Pagination } from 'element-react';
import { actionCreators } from '../../store';

class PageNation extends Component {

  handleChange(value) {
    const { chagnePageNum } = this.props;
    const parmas = {
      a_page: value
    }
    chagnePageNum(parmas);
    this.scrollToAnchor('anchorTop');
  }

  handleClickItem(flag) {
    this.props.history.push({
      pathname: '/detail/' + flag.get('id'), state: {
        type: 2,
        id: flag.get('id'),
        title: flag.get('name')
      }
    });
  }

  render() {

    const { list, pageSum } = this.props;

    return (
      <div className="page-nation">
        <div className="page-nation__wrap">
          <ul className="page-nation__group">
            {
              list.map((item) => {
                return (
                  <li className="page-nation__item" key={item.get('id')} onClick={this.handleClickItem.bind(this, item)}>
                    <h2 className="page-nation__item--title">
                      <span className="label">{item.get('domain')}</span>
                      <p className="desc">{item.get('name')}</p>
                    </h2>
                    <p className="page-nation__item--l-desc">{item.get('account')}</p>
                    <div className="page-nation__item--cta">
                      {
                        item.get('type') && item.get('type').map((i, index) => {
                          if (index === 0) {
                            return (
                              <div className="icon-box" key={index}>
                                <i className="iconfont">&#xe667;</i>
                                <p className="type">{i}</p>
                              </div>
                            )
                          }
                        })
                      }
                    </div>
                  </li>
                )
              })
            }
          </ul>

          {
            pageSum > 0 ? (
              <div className="page-nation__num">
                <Pagination layout="prev, pager, next" total={pageSum} onCurrentChange={this.handleChange.bind(this)} />
              </div>
            ) : null
          }

        </div>
      </div>
    )
  }

  scrollToAnchor(anchorName) {
    if (anchorName) {
      let anchorEle = document.getElementById(anchorName);
      if (anchorEle) {
        anchorEle.scrollIntoView({
          behavior: "smooth"
        });
      }
    }
  }
}

const mapState = (state) => ({
  list: state.getIn(['hall', 'list']),
  pageSum: state.getIn(['hall', 'pageSum'])
});

const mapDispatch = (dispatch) => ({
  chagnePageNum(obj) {
    dispatch(actionCreators.fetchHallData(obj))
  }
})

export default withRouter(connect(mapState, mapDispatch)(PageNation));
